import React, { useEffect, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";

import { Table, Input, Button, Space, Select, Tag, Divider, Image } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";

export class TableReportSup4 extends React.Component {
  static contextType = LanguageContext;
  render() {
    let tempColumns = [];
    // tempColumns =  this.props.columns
    // let columns =tempColumns.map((res) => {
    //   return {
    //     ...res,
    //   };
    // });

    // let columnsOb = [
    //     {
    //         title: "SrNo",
    //         key: "srNo",
    //         render: (text, record) => (
    //           <Space size="middle" style={{maxWidth:300}}>
    //               {record.srNo}
    //           </Space>
    //         ),

    //       },
    //   {
    //     title: "घटक",
    //     key: "policeThane",
    //     render: (text, record) => (
    //       <Space size="middle" style={{maxWidth:300}}>
    //           {record.policeThane}
    //       </Space>
    //     ),
    //   },
    //   {
    //     title: "एकूण आरोपी",
    //     key: "totalCriminals",
    //     render: (text, record) => (
    //       <Space size="middle" style={{maxWidth:300}}>
    //           {record.totalCriminals}
    //       </Space>
    //     ),
    //   },
    //   {
    //     title: "एकूण तपासलेले आरोपी",
    //     key: "totalCriminalsChecked",
    //     render: (text, record) => (
    //       <Space size="middle" style={{maxWidth:300}}>
    //           {record.totalCriminalsChecked}
    //       </Space>
    //     ),
    //   },
    //   {
    //     title: "मिटातून आले आरोपी",
    //     key: "totalFindCriminals",
    //     render: (text, record) => (
    //       <Space size="middle" style={{maxWidth:300}}>
    //        {record.totalFindCriminals}
    //       </Space>
    //     ),
    //   },
    // ]

    const { t } = this.context;

    const columnsOb = [
      {
        title: t("sr_no") || "SrNo",
        key: "srNo",
        render: (text, record) => <Space size="middle">{record.srNo}</Space>,
      },
      {
        title: t("name") || "नाव",
        key: "name",
        render: (text, record) => (
          <Space size="middle" title={record?.id}>
            {record.name || "-"}
          </Space>
        ),
      },
      {
        title: t("accused_police_station") || "आरोपीचे पोलिस ठाणे",
        key: "districtName",
        render: (text, record) => (
          <Space size="middle">{record.districtName || "-"}</Space>
        ),
      },
      {
        title: t("last check date") || "Last Check Date",
        key: "lastUpdate",
        render: (text, record) => (
          <Space size="middle">
            {record.lastUpdate
              ? moment.unix(record.lastUpdate).format("DD-MM-YYYY")
              : "-"}
          </Space>
        ),
      },
      {
        title: t("count") || "count",
        key: "activeUser",
        render: (text, record) => (
          <Space size="middle">
            <Button
              type="primary"
              shape="circle"
              size="small"
              style={{
                width: 36,
                height: 36,
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
            >
              {record.activeUser || 0}
            </Button>
          </Space>
        ),
      },
      {
        title: t("photo") || "फोटो",
        key: "photo",
        render: (text, record) => (
          <Space size="middle">
            {record.photo ? (
              <Image
                src={record.photo}
                alt="फोटो"
                width={40}
                height={40}
                style={{ objectFit: "cover", borderRadius: "4px" }}
              />
            ) : (
              "नाही"
            )}
          </Space>
        ),
      },
    ];

    // let tebleData = this.props.data && this.props.data.map((item,index)=>{
    //     return {
    //         ...item,
    //         srNo:index + 1
    //     }
    // })

    // // columns.push(
    // //   ...columnsOb
    // // );

    // return (
    //     <>
    //     <div style={{ marginBottom: 16 }}>

    //       <span style={{ marginLeft: 8 }}>

    //       </span>
    //     </div>
    //     <Divider orientation="left">एकुण आरोपी {this.props.total}/{this.props.allTotal} </Divider>
    //     <Table columns={columnsOb} dataSource={tebleData} />
    //     </>
    // );

    const tableData =
      this.props.data?.map((item, index) => ({
        ...item,
        srNo: index + 1,
      })) || [];

    return (
      <>
        <div style={{ marginBottom: 16 }}></div>
        <Divider orientation="left">
          {t("accused_not_yet_checked") || "अद्याप चेक न केलेले आरोपी"}{" "}
          {this.props.total}/{this.props.allTotal}
        </Divider>
        <Table
          bordered
          loading={this.props.loading}
          columns={columnsOb}
          dataSource={tableData}
          pagination={{ pageSize: 10 }}
          rowKey={(record, index) => index}
          rowClassName={() => "govt-table-row"}
        />
      </>
    );
  }
}
